module.exports = __webpack_public_path__ + "static/g-IdePaz-d5796dc66125ed1855ccace4ddb6d075.jpg";